<template>
    <q-page class="q-pa-md">
        <!-- DIALOG PARA VER DETALLES -->
        <q-dialog full-width v-model="dialogDetalles" persistent>
            <q-card style="background: #f8fcff">
                <q-bar class="bg-primary text-white">
                    <q-icon name="mdi-bank" />
                    <div>Detalles</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section>
                    <q-table dense :loading="loadingDetalles" title="Treats" style="height: 100%;"
                        :filter="filterDetalles" :data="dataDetalles" :columns="columnsBienes" row-key="name">
                        <template v-slot:loading>
                            <q-inner-loading showing color="primary" />
                        </template>
                        <template v-slot:top>
                            <div full-width class="row full-width q-pb-sm">
                                <div class="col-12 row">
                                    <div class="text-h5">{{ titulo }}</div>
                                    <q-space></q-space>
                                    <q-btn class="text-primary" label="Exportar Excel" color="primary"
                                        icon="mdi-file-excel" @click="exportTable()">
                                        <q-tooltip>
                                            Generar Excel
                                        </q-tooltip>
                                    </q-btn>
                                </div>
                                <div class="col-12 q-mt-md">
                                    <q-input dense filled v-model="filterDetalles" label="Buscar" />
                                </div>
                            </div>
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td key="numero_emp" :props="props">{{ props.row.numero_emp }}</q-td>
                                <q-td key="unidad_negocio" :props="props">{{ props.row.unidad_negocio }}</q-td>
                                <q-td key="ui_estado" :props="props">{{ props.row.ui_estado }}</q-td>
                                <q-td key="cc_estado" :props="props">{{ props.row.cc_estado }}</q-td>
                                <q-td key="combinacion" :props="props">{{ props.row.combinacion }}</q-td>
                                <q-td key="numero_acta" :props="props">{{ props.row.numero_acta }}</q-td>
                                <q-td key="categoria" :props="props">{{ props.row.categoria }}</q-td>
                                <q-td key="no_alta" :props="props">{{ props.row.no_alta }}</q-td>
                                <q-td key="id_activo" :props="props">{{ props.row.id_activo }}</q-td>
                                <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                <q-td key="comple_desc" :props="props">{{ props.row.comple_desc }}</q-td>
                                <q-td key="id_articulo" :props="props">{{ props.row.id_articulo }}</q-td>
                                <q-td key="descr_articulo" :props="props">{{ props.row.descr_articulo }}</q-td>
                                <q-td key="nom_fabricante" :props="props">{{ props.row.nom_fabricante }}</q-td>
                                <q-td key="modelo" :props="props">{{ props.row.modelo }}</q-td>
                                <q-td key="id_serie" :props="props">{{ props.row.id_serie }}</q-td>
                                <q-td key="clase" :props="props">{{ props.row.clase }}</q-td>
                                <q-td key="fecha_ultmo_mov" :props="props">{{ props.row.fecha_ultmo_mov
                                }}</q-td>
                                <q-td key="uni_oper" :props="props">{{ props.row.uni_oper }}</q-td>
                                <q-td key="no_movimiento" :props="props">{{ props.row.no_movimiento }}</q-td>
                                <q-td key="unidad_info" :props="props">{{ props.row.unidad_info }}</q-td>
                                <q-td key="tipo_resguardo" :props="props">{{ props.row.tipo_resguardo }}</q-td>
                                <q-td key="descr_unidad" :props="props">{{ props.row.descr_unidad }}</q-td>
                                <q-td key="centro_costo" :props="props">{{ props.row.centro_costo }}</q-td>
                                <q-td key="descr_centro" :props="props">{{ props.row.descr_centro }}</q-td>
                                <q-td key="sr" :props="props">{{ props.row.sr }}</q-td>
                                <q-td key="num_usuarios" :props="props">{{ props.row.num_usuarios }}</q-td>
                                <q-td key="costo" :props="props">{{ props.row.costo }}</q-td>
                                <q-td key="depreciacion_acum" :props="props">{{ props.row.depreciacion_acum }}</q-td>
                                <q-td key="fecha_adquisicion" :props="props">{{ props.row.fecha_adquisicion
                                }}</q-td>
                                <q-td key="fecha_alta" :props="props">{{ props.row.fecha_alta }}</q-td>
                                <q-td key="comentario_nni" :props="props">{{ props.row.comentario_nni }}</q-td>
                                <q-td key="contrato" :props="props">{{ props.row.contrato }}</q-td>
                                <q-td key="ubicacion" :props="props">{{ props.row.ubicacion }}</q-td>
                                <q-td key="division" :props="props">{{ props.row.division }}</q-td>
                                <q-td key="subdivision" :props="props">{{ props.row.subdivision }}</q-td>
                                <q-td key="matricula" :props="props">{{ props.row.matricula }}</q-td>
                                <q-td key="nom_usuario" :props="props">{{ props.row.nom_usuario }}</q-td>
                                <q-td key="matricula_rcab" :props="props">{{ props.row.matricula_rcab }}</q-td>
                                <q-td key="nombre_rcab" :props="props">{{ props.row.nombre_rcab }}</q-td>

                                <!-- <q-td key="nombre_emp" :props="props">{{ props.row.nombre_emp }}</q-td>
                                <q-td key="descripcion_emp" :props="props">{{ props.row.descripcion_emp
                                }}</q-td>
                                <q-td key="marca_emp" :props="props">{{ props.row.marca_emp }}</q-td>
                                <q-td key="serie_emp" :props="props">{{ props.row.serie_emp }}</q-td>
                                <q-td key="modelo_emp" :props="props">{{ props.row.modelo_emp }}</q-td>
                                <q-td key="est_conserv_emp" :props="props">{{ props.row.est_conserv_emp
                                }}</q-td>
                                <q-td key="descr_categoria" :props="props">{{ props.row.descr_categoria
                                }}</q-td>
                                <q-td key="ubicacion_emp" :props="props">{{ props.row.ubicacion_emp }}</q-td>
                                <q-td key="usuario_emp" :props="props">{{ props.row.usuario_emp }}</q-td>
                               
                                <q-td key="municipio" :props="props">{{ props.row.municipio }}</q-td>
                                <q-td key="resultado_emp" :props="props">{{ props.row.resultado_emp }}</q-td>
                                <q-td key="obeservaciones_emp" :props="props">{{ props.row.obeservaciones_emp
                                }}</q-td> -->
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>

        <!-- DIALOG SUBIR NUEVA BASE -->
        <q-dialog full-width v-model="dialogNuevaBase" persistent>
            <q-card style="background: #f8fcff">
                <q-bar class="bg-primary text-white">
                    <q-icon name="mdi-bank" />
                    <div>Cargar Nueva Base</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section>
                    <div class="row q-col-gutter-md">
                        <div class="col-12">
                            <q-table dense :loading="loadingBienes" title="Treats" style="height: 100%;"
                                :filter="filter" :data="dataBienes" :columns="columnsBienes" row-key="name">
                                <template v-slot:loading>
                                    <q-inner-loading showing color="primary" />
                                </template>
                                <template v-slot:top>
                                    <div full-width class="row full-width q-pb-sm">
                                        <div class="text-h5">Bienes</div>
                                    </div>

                                    <div class="row full-width q-col-gutter-md">
                                        <div class="col-12 col-md-4 q-mb-md">
                                            <q-select v-model="objSede" full-width label="Sede" :options="dataSedes"
                                                dense filled option-label="sede" @input="GetUnidades">
                                                <template v-slot:no-option>
                                                    <q-item>
                                                        <q-item-section class="text-grey">
                                                            Sin Datos
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-12 col-md-4 q-mb-md">
                                            <q-select v-model="objTipoUnidad" @input="GetUnidades" full-width
                                                label="Tipo de Unidad" :options="dataTipoUnidad" dense filled
                                                option-label="tipo_unidad">
                                                <template v-slot:no-option>
                                                    <q-item>
                                                        <q-item-section class="text-grey">
                                                            Sin Datos
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-select v-model="objUnidad" full-width label="Unidad"
                                                :options="dataUnidad" dense filled option-label="unidad"
                                                :loading="loadingUnidades">
                                                <template v-slot:no-option>
                                                    <q-item>
                                                        <q-item-section class="text-grey">
                                                            Sin Datos
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-12">
                                            <q-uploader style="min-width: 100%;" label="Sube tu archivo Excel"
                                                accept=".xlsx, .xls" @added="onFileAdded" />
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:body="props">
                                    <q-tr :props="props">
                                        <q-td key="numero_emp" :props="props">{{ props.row.numero_emp }}</q-td>
                                        <q-td key="unidad_negocio" :props="props">{{ props.row.unidad_negocio }}</q-td>
                                        <q-td key="ui_estado" :props="props">{{ props.row.ui_estado }}</q-td>
                                        <q-td key="cc_estado" :props="props">{{ props.row.cc_estado }}</q-td>
                                        <q-td key="combinacion" :props="props">{{ props.row.combinacion }}</q-td>
                                        <q-td key="numero_acta" :props="props">{{ props.row.numero_acta }}</q-td>
                                        <q-td key="categoria" :props="props">{{ props.row.categoria }}</q-td>
                                        <q-td key="no_alta" :props="props">{{ props.row.no_alta }}</q-td>
                                        <q-td key="id_activo" :props="props">{{ props.row.id_activo }}</q-td>
                                        <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                        <q-td key="comple_desc" :props="props">{{ props.row.comple_desc }}</q-td>
                                        <q-td key="id_articulo" :props="props">{{ props.row.id_articulo }}</q-td>
                                        <q-td key="descr_articulo" :props="props">{{ props.row.descr_articulo }}</q-td>
                                        <q-td key="nom_fabricante" :props="props">{{ props.row.nom_fabricante }}</q-td>
                                        <q-td key="modelo" :props="props">{{ props.row.modelo }}</q-td>
                                        <q-td key="id_serie" :props="props">{{ props.row.id_serie }}</q-td>
                                        <q-td key="clase" :props="props">{{ props.row.clase }}</q-td>
                                        <q-td key="fecha_ultmo_mov" :props="props">{{ props.row.fecha_ultmo_mov
                                        }}</q-td>
                                        <q-td key="uni_oper" :props="props">{{ props.row.uni_oper }}</q-td>
                                        <q-td key="no_movimiento" :props="props">{{ props.row.no_movimiento }}</q-td>
                                        <q-td key="unidad_info" :props="props">{{ props.row.unidad_info }}</q-td>
                                        <q-td key="tipo_resguardo" :props="props">{{ props.row.tipo_resguardo }}</q-td>
                                        <q-td key="descr_unidad" :props="props">{{ props.row.descr_unidad }}</q-td>
                                        <q-td key="centro_costo" :props="props">{{ props.row.centro_costo }}</q-td>
                                        <q-td key="descr_centro" :props="props">{{ props.row.descr_centro }}</q-td>
                                        <q-td key="sr" :props="props">{{ props.row.sr }}</q-td>
                                        <q-td key="num_usuarios" :props="props">{{ props.row.num_usuarios }}</q-td>
                                        <q-td key="costo" :props="props">{{ props.row.costo }}</q-td>
                                        <q-td key="depreciacion_acum" :props="props">{{ props.row.depreciacion_acum
                                        }}</q-td>
                                        <q-td key="fecha_adquisicion" :props="props">{{ props.row.fecha_adquisicion
                                        }}</q-td>
                                        <q-td key="fecha_alta" :props="props">{{ props.row.fecha_alta }}</q-td>
                                        <q-td key="comentario_nni" :props="props">{{ props.row.comentario_nni }}</q-td>
                                        <q-td key="contrato" :props="props">{{ props.row.contrato }}</q-td>
                                        <q-td key="ubicacion" :props="props">{{ props.row.ubicacion }}</q-td>
                                        <q-td key="division" :props="props">{{ props.row.division }}</q-td>
                                        <q-td key="subdivision" :props="props">{{ props.row.subdivision }}</q-td>
                                        <q-td key="matricula" :props="props">{{ props.row.matricula }}</q-td>
                                        <q-td key="nom_usuario" :props="props">{{ props.row.nom_usuario }}</q-td>
                                        <q-td key="matricula_rcab" :props="props">{{ props.row.matricula_rcab }}</q-td>
                                        <q-td key="nombre_rcab" :props="props">{{ props.row.nombre_rcab }}</q-td>




                                        <!-- <q-td key="nombre_emp" :props="props">{{ props.row.nombre_emp }}</q-td>
                                <q-td key="descripcion_emp" :props="props">{{ props.row.descripcion_emp
                                }}</q-td>
                                <q-td key="marca_emp" :props="props">{{ props.row.marca_emp }}</q-td>
                                <q-td key="serie_emp" :props="props">{{ props.row.serie_emp }}</q-td>
                                <q-td key="modelo_emp" :props="props">{{ props.row.modelo_emp }}</q-td>
                                <q-td key="est_conserv_emp" :props="props">{{ props.row.est_conserv_emp
                                }}</q-td>
                                <q-td key="descr_categoria" :props="props">{{ props.row.descr_categoria
                                }}</q-td>
                                <q-td key="ubicacion_emp" :props="props">{{ props.row.ubicacion_emp }}</q-td>
                                <q-td key="usuario_emp" :props="props">{{ props.row.usuario_emp }}</q-td>
                                
                               
                                <q-td key="municipio" :props="props">{{ props.row.municipio }}</q-td>
                                <q-td key="resultado_emp" :props="props">{{ props.row.resultado_emp }}</q-td>
                                <q-td key="obeservaciones_emp" :props="props">{{ props.row.obeservaciones_emp
                                }}</q-td> -->
                                    </q-tr>
                                </template>
                            </q-table>
                            <!-- <div class="row">
                                <q-badge style="font-size: 30px; padding: 10px;" color="blue">
                                    5000
                                </q-badge>
                            </div> -->

                        </div>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn flat label="Descargar Plantilla de Excel" color="primary" @click="DescargarPlantilla()" />
                    <q-btn flat label="Cancelar" color="primary" v-close-popup />
                    <q-btn flat push label="Guardar" color="primary" @click="PostDatosBienes()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALOGO DE CONFIRMACION ELIMINAR BASE DE DATOS-->
        <q-dialog v-model="dialogConfirmDelete" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar la base de datos de la unidad
                                <strong>{{
                                    itemBD.nombre_unidad
                                    }}</strong> con <strong>{{ itemBD.noDatos
                                    }}</strong> registros.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">La eliminación de la base de datos implica la pérdida irreversible de la información
                            contenida. Sin embargo, será posible cargar una nueva base de datos.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDeleteBD()" />
                    <q-btn label="Aceptar" color="primary" @click="DeleteItemBD()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="row q-col-gutter-md q-mt-sm">
            <div class="col-12 col-md-12">
                <q-table dense :loading="loading" title="Treats" style="height: 100%;" :filter="filter" :data="data"
                    :columns="columns" row-key="name">
                    <template v-slot:loading>
                        <q-inner-loading showing color="primary" />
                    </template>
                    <template v-slot:top>
                        <div class="text-h5">Base de datos</div>
                        <q-space />
                        <q-btn color="primary" icon="mdi-plus" label="CARGAR NUEVA BASE"
                            @click="abrirDialogNuevaBase()" />
                        <q-btn round color="primary" icon="mdi-refresh" class="q-ml-md" @click="GetTablas()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props">
                            <q-td key="nombre_sede" :props="props">{{ props.row.nombre_sede }}</q-td>
                            <q-td key="nombre_tipo_unidad" :props="props">{{ props.row.nombre_tipo_unidad }}</q-td>
                            <q-td key="nombre_unidad" :props="props">{{ props.row.nombre_unidad }}</q-td>
                            <q-td key="noDatos" :props="props">{{ props.row.noDatos }}</q-td>
                            <q-td auto-width key="acciones">

                                <q-btn size="md" color="primary" rounded flat dense @click="eliminarBd(props.row)"
                                    icon="mdi-delete">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Eliminar BD</q-tooltip>
                                </q-btn>
                                <q-btn size="md" color="primary" rounded flat dense @click="verDetalles(props.row)"
                                    icon="mdi-format-list-bulleted">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Ver Datos</q-tooltip>
                                </q-btn>
                                <q-btn size="md" color="primary" rounded flat dense @click="exportarQR(props.row)"
                                    icon="mdi-qrcode">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Generar QR</q-tooltip>
                                </q-btn>
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import { format } from 'date-fns';
import { date, QSpinnerFacebook } from 'quasar'
import moment from 'moment';
import axios from "axios";
import * as XLSX from 'xlsx';
import { exportFile } from 'quasar'

function wrapCsvValue(val, formatFn) {
    let formatted = formatFn !== void 0
        ? formatFn(val)
        : val

    formatted = formatted === void 0 || formatted === null
        ? ''
        : String(formatted)

    formatted = formatted.split('"').join('""')
    return `"${formatted}"`
}

export default {

    components: {
    },
    data() {
        return {
            columns: [
                { name: 'nombre_sede', align: 'center', label: 'Sede', field: 'nombre_sede', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'nombre_tipo_unidad', align: 'center', label: 'Tipo de Unidad', field: 'nombre_tipo_unidad', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'nombre_unidad', align: 'center', label: 'Unidad', field: 'nombre_unidad', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'noDatos', align: 'center', label: 'No. Bienes', field: 'noDatos', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            data: [],
            loading: false,
            filter: '',

            filter: '',
            dataBienes: [],
            columnsBienes: [
                { name: 'numero_emp', align: 'center', label: 'Número', field: 'numero_emp', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-secondary text-white text-center' },
                { name: 'unidad_negocio', align: 'center', label: 'UN', field: 'unidad_negocio', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'ui_estado', align: 'center', label: 'Año', field: 'ui_estado', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'cc_estado', align: 'center', label: 'Periodo', field: 'cc_estado', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'combinacion', align: 'center', label: 'Cuenta PREI', field: 'combinacion', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'numero_acta', align: 'center', label: 'Descripción', field: 'numero_acta', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'categoria', align: 'center', label: 'Categoria', field: 'categoria', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'no_alta', align: 'center', label: 'Descripción de la Categoria', field: 'no_alta', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'id_activo', align: 'center', label: 'Número Nacional de Inventario', field: 'id_activo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'descripcion', align: 'center', label: 'Descripción del Bien', field: 'descripcion', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'comple_desc', align: 'center', label: 'Caracteristicas del Bien', field: 'comple_desc', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'id_articulo', align: 'center', label: 'ID del Artículo', field: 'id_articulo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'descr_articulo', align: 'center', label: 'Descripción del Artículo', field: 'descr_articulo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'nom_fabricante', align: 'center', label: 'Marca', field: 'nom_fabricante', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'modelo', align: 'center', label: 'Modelo', field: 'modelo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'id_serie', align: 'center', label: 'ID Serie', field: 'id_serie', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'clase', align: 'center', label: 'Clase', field: 'clase', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'fecha_ultmo_mov', align: 'center', label: 'Descripción de la Clase', field: 'fecha_ultmo_mov', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'uni_oper', align: 'center', label: 'Unidad Operativa', field: 'uni_oper', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'no_movimiento', align: 'center', label: 'Descripción de la Unidad Operativa', field: 'no_movimiento', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'unidad_info', align: 'center', label: 'Unidad de la Información', field: 'unidad_info', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'tipo_resguardo', align: 'center', label: 'Validar UI', field: 'tipo_resguardo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'descr_unidad', align: 'center', label: 'Descripción de la Unidad de Información', field: 'descr_unidad', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'centro_costo', align: 'center', label: 'Centro de Costo', field: 'centro_costo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'descr_centro', align: 'center', label: 'Descripción del Centro de Costos', field: 'descr_centro', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'sr', align: 'center', label: 'Seguro Ramo', field: 'sr', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'num_usuarios', align: 'center', label: 'Descripción Seguro Ramo', field: 'num_usuarios', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'costo', align: 'center', label: 'Inversión', field: 'costo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'depreciacion_acum', align: 'center', label: 'Depreciasión Acumulada', field: 'depreciacion_acum', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'fecha_adquisicion', align: 'center', label: 'Fecha de Adquisición', field: 'fecha_adquisicion', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'fecha_alta', align: 'center', label: 'Fecha de Alta', field: 'fecha_alta', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'comentario_nni', align: 'center', label: 'Nota Recepción', field: 'comentario_nni', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'contrato', align: 'center', label: 'Contrato IMSS', field: 'contrato', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'ubicacion', align: 'center', label: 'Ubicación', field: 'ubicacion', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'division', align: 'center', label: 'División', field: 'division', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'subdivision', align: 'center', label: 'Subdivisión', field: 'subdivision', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'matricula', align: 'center', label: 'Matricula Usuario Responsable', field: 'matricula', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'nom_usuario', align: 'center', label: 'Nombre Usuario Responsable', field: 'nom_usuario', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'matricula_rcab', align: 'center', label: 'Matricula RCAB', field: 'matricula_rcab', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'nombre_rcab', align: 'center', label: 'Nombre de RCAB', field: 'nombre_rcab', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            loadingBienes: false,
            dialogNuevaBase: false,

            objTipoUnidad: {
                tipo_unidad: ''
            },

            objSede: {
                sede: ''
            },

            objUnidad: {
                unidad: ''
            },
            dataUnidad: [],
            loadingUnidades: false,

            dialogDetalles: false,
            filterDetalles: '',
            dataDetalles: [],
            loadingDetalles: false,

            nombreArchivo: '',
            titulo: '',

            dialogConfirmDelete: false,
            itemBD: {}
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario
        },
        dataSedes() {
            return this.$store.state.dataSedesStore
        },
        dataTipoUnidad() {
            return this.$store.state.dataTipoUnidadesStore
        }
    },
    created() {
        this.GetSedesTodos();
        this.GetTipoUnidades();
        this.GetTablas()
    },
    methods: {
        DescargarPlantilla() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            const url = '/Plantilla_Activos.xlsx';
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Plantilla_Activos.xlsx';
            link.click();
        },

        async verDetalles(item) {
            this.titulo = item.nombre_unidad
            this.nombreArchivo = this.usuarioStore.estado + '_' + item.nombre_sede + '_' + item.nombre_tipo_unidad + '_' + item.nombre_unidad

            this.dialogDetalles = true
            this.loadingDetalles = true
            let obj = {
                bd_estado: item.bd_estado,
                tabla_unidad: item.tabla_unidad
            }
            console.log(obj)
            try {
                let respuesa = await axios.post('Configuracion/GetDetalles/', obj)
                console.log(respuesa)
                this.loadingDetalles = false
                this.dataDetalles = respuesa.data
            } catch (error) {
                this.loadingDetalles = false
                console.log(error)
            }
        },

        onFileAdded(files) {
            let columns = []
            let tableData = []
            const file = files[0];
            const reader = new FileReader();

            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                // Asumiendo que la primera hoja es la que queremos leer
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];

                // Convirtiendo la hoja a JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                // Transformar los datos para q-table
                if (jsonData.length) {
                    columns = jsonData[0].map((header, index) => ({
                        name: index,
                        align: 'left',
                        label: header,
                        field: row => row[index],
                        sortable: true
                    }));
                    tableData = jsonData.slice(1).map((row, index) => ({
                        id: index,
                        ...row
                    }));
                    let counter = 1;
                    for (let c of tableData) {
                        const toDate = (val) => {
                            if (!val || isNaN(val)) return val; // si no es número, devuelves el valor original
                            const parsed = XLSX.SSF.parse_date_code(val);
                            if (!parsed) return val;
                            // Formato YYYY-MM-DD
                            return `${parsed.y}-${String(parsed.m).padStart(2, '0')}-${String(parsed.d).padStart(2, '0')}`;
                        };
                        let a = {
                            numero_emp: counter++,
                            unidad_negocio: c['0'] ?? "",
                            ui_estado: c['1'] ?? "",
                            cc_estado: c['2'] ?? "",
                            combinacion: c['3'] ?? "",
                            numero_acta: c['4'] ?? "",
                            categoria: c['5'] ?? "",
                            no_alta: c['6'] ?? "",
                            id_activo: c['7'] ?? "",
                            descripcion: c['8'] ?? "",
                            comple_desc: c['9'] ?? "",
                            id_articulo: c['10'] ?? "",
                            descr_articulo: c['11'] ?? "",
                            nom_fabricante: c['12'] ?? "",
                            modelo: c['13'] ?? "",
                            id_serie: c['14'] ?? "",
                            clase: c['15'] ?? "",
                            fecha_ultmo_mov: c['16'] ?? "",
                            uni_oper: c['17'] ?? "",
                            no_movimiento: c['18'] ?? "",
                            unidad_info: c['19'] ?? "",
                            tipo_resguardo: c['20'] ?? "",
                            descr_unidad: c['21'] ?? "",
                            centro_costo: c['22'] ?? "",
                            descr_centro: c['23'] ?? "",
                            sr: c['24'] ?? "",
                            num_usuarios: c['25'] ?? "",
                            costo: c['26'] ?? "",
                            depreciacion_acum: c['27'] ?? "", // <------ NUEVO
                            fecha_adquisicion: toDate(c['28']) ?? "",
                            fecha_alta: toDate(c['29']) ?? "",// <------ NUEVO
                            comentario_nni: c['30'] ?? "",
                            contrato: c['31'] ?? "",
                            ubicacion: c['32'] ?? "",
                            division: c['33'] ?? "",
                            subdivision: c['34'] ?? "",
                            matricula: c['35'] ?? "",
                            nom_usuario: c['36'] ?? "",
                            matricula_rcab: c['37'] ?? "", // <------ NUEVO
                            nombre_rcab: c['38'] ?? "",
                            estatus_emp: "NO IDENTIFICADO",



                            // municipio: c['46'],
                            // evidenacia_emp: [],
                            // resultado_emp: c['48'],
                            // obeservaciones_emp: c['49'],
                            // estatus: ''
                        }
                        this.dataBienes.push(a)
                    }
                    // this.dialogSubirExcel = false
                }
            };

            reader.readAsArrayBuffer(file);
        },

        abrirDialogNuevaBase() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.dataBienes = []
            this.objTipoUnidad = {
                tipo_unidad: ''
            },

                this.objSede = {
                    sede: ''
                }

            this.objUnidad = {
                unidad: ''
            }
            this.dialogNuevaBase = true
        },

        async GetSedesTodos() {
            try {
                let respuesa = await axios.get('Configuracion/GetSedesTodos/' + this.usuarioStore.baseDatos)
                console.log(respuesa)
                this.$store.state.dataSedesStore = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetTipoUnidades() {

            try {
                let respuesa = await axios.get('Configuracion/GetTipoUnidades/' + this.usuarioStore.baseDatos)
                console.log(respuesa)
                this.$store.state.dataTipoUnidadesStore = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetUnidades() {
            this.objUnidad = {
                unidad: ''
            }
            if (this.objSede.sede == '') {
                return
            }
            if (this.objTipoUnidad.tipo_unidad == '') {
                return
            }
            this.loadingUnidades = true

            try {
                let respuesa = await axios.get('Configuracion/GetUnidadesXid/' + this.usuarioStore.baseDatos + '/' + this.objSede._id + '/' + this.objTipoUnidad._id)
                console.log(respuesa)
                this.loadingUnidades = false
                this.dataUnidad = respuesa.data
            } catch (error) {
                this.loadingUnidades = false
                console.log(error)
            }
        },
        async PostDatosBienes() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            if (this.objSede.sede == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique una contraseña.' })
                return;
            }
            if (this.objTipoUnidad.tipo_unidad == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique un tipo de Unidad.' })
                return;
            }
            if (this.objUnidad.unidad == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique la unidad.' })
                return;
            }

            if (this.dataBienes.length == 0) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'No hay datos que guardar.' })
                return;
            }
            let fecha = new Date()
            let fechaC = format(fecha, "yyyy-MM-dd HH:mm:ss");

            let objeto = {
                _id: '',
                bd_estado: this.usuarioStore.baseDatos,
                _id_sede: this.objSede._id,
                _id_tipo_unidad: this.objTipoUnidad._id,
                _id_unidad: this.objUnidad._id,
                tabla_unidad: '',
                estado: 'Vigente',
                datos: this.dataBienes,
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: fechaC,
                noDatos: this.dataBienes.length
            }
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Guardando Base de Datos. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostDatosBienes/' + this.usuarioStore.baseDatos, objeto)
                console.log(respuesa)
                this.$q.loading.hide()
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Base de Datos guardada exitosamente.` })

                this.dialogNuevaBase = false
            } catch (error) {
                this.$q.loading.hide()

                console.log(error)
            }
        },

        async GetTablas() {
            this.loading = true
            try {
                let respuesa = await axios.get('Configuracion/GetTablas/' + this.usuarioStore.baseDatos +'/'+ this.usuarioStore._id + '/' + this.usuarioStore.rol)
                console.log(respuesa)
                this.loading = false
                this.data = respuesa.data
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        exportTable() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            // naive encoding to csv format
            const content = [this.columnsBienes.map(col => wrapCsvValue(col.label))].concat(
                this.dataDetalles.map(row => this.columnsBienes.map(col => wrapCsvValue(
                    typeof col.field === 'function'
                        ? col.field(row)
                        : row[col.field === void 0 ? col.name : col.field],

                    col.format
                )).join(','))
            ).join('\r\n')

            const status = exportFile(
                this.nombreArchivo + '.csv',
                content,
                'text/csv'
            )

            if (status !== true) {
                this.$q.notify({
                    message: 'Browser denied file download...',
                    color: 'negative',
                    icon: 'warning'
                })
            }
        },

        async exportarQR(data) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            let nombreArchivo = 'DATOS-QR_' + this.usuarioStore.estado + '_' + data.nombre_sede + '_' + data.nombre_tipo_unidad + '_' + data.nombre_unidad
            let obj = {
                bd_estado: data.bd_estado,
                tabla_unidad: data.tabla_unidad
            }
            try {
                let respuesa = await axios.post('Configuracion/GetDetalles/', obj)
                console.log(respuesa)
                this.dataDetalles = respuesa.data

                const lista = []
                if (data.bd_estado == 'inv_morelos'){
                    for (let a of this.dataDetalles) {
                    let obj = {
                        nni: a.id_activo,
                        nombre: a.descripcion,
                        // url: 'http://localhost:8080/InfoQR/?inv=' + data.bd_estado + '&unidad=none' + '&_id=' + a.id_activo
                        url: 'https://gestor-viwer.contago.com.mx/InfoQR?inv=' + data.bd_estado + '&unidad=none' + '&_id=' + a.id_activo
                    }
                    lista.push(obj)
                    }
                }else{
                    for (let a of this.dataDetalles) {
                    let obj = {
                        nni: a.id_activo,
                        nombre: a.descripcion,
                        // url: 'http://localhost:8080/InfoQR/?inv=' + data.bd_estado + '&unidad=' + data.tabla_unidad + '&_id=' + a._id
                        url: 'https://gestor-viwer.contago.com.mx/InfoQR?inv=' + data.bd_estado + '&unidad=' + data.tabla_unidad + '&_id=' + a._id
                    }
                    lista.push(obj)
                    }
                }
                
                // Renombrar campos con los títulos personalizados
                const datosConCabeceras = lista.map(item => ({
                    'NNI': item.nni,
                    'NOMBRE': item.nombre,
                    'URL': item.url
                }));

                // Crear una hoja de cálculo a partir de los datos
                const worksheet = XLSX.utils.json_to_sheet(datosConCabeceras);

                // Crear el libro de Excel
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'MiHoja');

                // Descargar el archivo
                XLSX.writeFile(workbook, nombreArchivo + '.xlsx');
            } catch (error) {
                console.log(error)
            }
        },

        eliminarBd(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            console.log(item)
            this.itemBD = item
            this.dialogConfirmDelete = true
        },

        cancelarDeleteBD() {
            this.itemBD = {
            }
            this.dialogConfirmDelete = false
        },

        async DeleteItemBD() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Eliminando Base de Datos. Espere...', messageColor: 'white' })

            try {
                let respuesa = await axios.post('Configuracion/DeleteDatosBienes/' + this.usuarioStore.baseDatos, this.itemBD)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Base de datos eliminado correctamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarDeleteBD();
                await this.GetTablas();

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
    }
}
</script>